
const $ = jQuery;

const	$newsletter = $('.js-subscribe-to-mail'),
		$newsletterInput = $newsletter.find('.js-input'),
		$newsletterEmailInput = $newsletter.find('input[type=email]'),
		$newsletterConsent = $('.js-subscribe-to-mail-consent'),
		$newsletterForm = $('.subscribe-to-mail');

if ( $newsletter.length ) {
	
	if ( $.trim($newsletterEmailInput.val()) === '' ) {
		$newsletterConsent.css({ "display": "none" });
	}

	$newsletterInput.on('click', function() {
		$newsletterConsent.slideDown(500);
	});

	$newsletterForm.submit(function(e) {

		e.preventDefault();

		var mailchimpform = $(this);

		$.ajax({
			url:mailchimpform.attr('action'),
			type:'POST',
			data:mailchimpform.serialize(),
			success:function(data){
				if(!data.success) {
					alert(data.message);
				} else {
					mailchimpform.parent().html(`<p class="fs-xl fc-green">${data.message}</p>`);
				}
			}
		});
		return false;
	});
}